/**
 * Reusable component for bulk remediation actions
 * Shows Add/Remove buttons based on selected items
 */
import React from 'react';

const BulkRemediationActions = ({ 
  selectedIds, 
  itemsToAdd, 
  itemsToRemove, 
  onBulkAdd, 
  onBulkRemove,
  clientType 
}) => {
  if (/*clientType !== "Admin" || */selectedIds.length === 0) {
    return null;
  }

  return (
    <div className="col-md-4 mt-1 col-sm-12 text-left">
      {/* Add Selected Button */}
      {itemsToAdd.length > 0 && (
        <button
          onClick={onBulkAdd}
          className="btn btn-success mr-2"
          style={{ fontWeight: "bold" }}
        >
          <i className="fa fa-plus" style={{ marginRight: "5px" }}></i>
          Add Selected ({itemsToAdd.length})
        </button>
      )}
      
      {/* Remove Selected Button */}
      {itemsToRemove.length > 0 && (
        <button
          onClick={onBulkRemove}
          className="btn btn-warning mr-2"
          style={{ fontWeight: "bold" }}
        >
          <i className="fa fa-minus" style={{ marginRight: "5px" }}></i>
          Remove Selected ({itemsToRemove.length})
        </button>
      )}
    </div>
  );
};

export default BulkRemediationActions;
